import { useEffect } from "react";
import Requisition from '../table/Tablerequisition';
import Modal from "../modal/Modaladdrequisition"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Requisition/>
    
     
     </>
  );
};

export default Dashboard;
